<div class="px-4 sm:px-6 lg:px-8 py-6">
  <h1 class="text-3xl sm:text-4xl font-bold text-white drop-shadow-lg">
    <ng-content></ng-content>
  </h1>
</div>
